// Thin compatibility layer over src/lib/googleTracking.ts.
// All Google measurement now flows through the central module so we get
// a single Consent Mode, a single page_view path, and no duplicate hits.

import {
  getGoogleTrackingConfig,
  trackGooglePageView,
  trackGoogleEvent,
  trackGooglePhoneConversion,
  trackGoogleEmailConversion,
  trackGoogleQuoteConversion,
  trackGoogleLeadConversion,
} from './googleTracking';

export const GA_MEASUREMENT_ID = getGoogleTrackingConfig().ga4MeasurementId;

type AnalyticsParams = Record<string, string | number | boolean | undefined>;

export const isGaEnabled = () => Boolean(getGoogleTrackingConfig().ga4MeasurementId);

export const trackPageView = (path: string, title = document.title) =>
  trackGooglePageView({ page_path: path, page_title: title });

export const trackEvent = (name: string, params: AnalyticsParams = {}) =>
  trackGoogleEvent(name, params);

export const trackPhoneClick = (location: string, page = window.location.pathname) =>
  trackGooglePhoneConversion({ form_id: location, page_path: page });

export const trackEmailClick = (location: string, page = window.location.pathname) =>
  trackGoogleEmailConversion({ form_id: location, page_path: page });

// Quote / contact submit helpers retained for callers that fire BEFORE the
// canonical conversion in useVisitorTracking.trackFormSubmission. They emit
// only lightweight GA4/GTM events; the real Ads conversion is fired once,
// after success, by useVisitorTracking.
export const trackQuoteFormSubmit = (formId: string, page = window.location.pathname) =>
  trackGoogleEvent('quote_form_submit', { form_id: formId, page_path: page });

export const trackContactFormSubmit = (formId: string, page = window.location.pathname) =>
  trackGoogleEvent('contact_form_submit', { form_id: formId, page_path: page });

export const trackRoofingCtaClick = (
  ctaLabel: string,
  page = window.location.pathname,
  location = 'unknown',
) =>
  trackGoogleEvent('click', {
    cta_label: ctaLabel,
    page_path: page,
    link_location: location,
  });

// Re-export the canonical lead conversion for callers that need it directly.
export { trackGoogleLeadConversion, trackGoogleQuoteConversion };
